import { CourseDef } from '../../../../types';
import L3893620 from './3893620';
import L3893614 from './3893614';
import L2079350 from './2079350';
import L2079351 from './2079351';
import L2079352 from './2079352';
import L5472572 from './5472572';
// import L5234409 from './5234409';
import L5234410 from './5234410';

export const aMelhorCorretora: CourseDef = {
  courseTitle: 'A MELHOR CORRETORA',
  lessons: [
    L3893620,
    L3893614,
    L2079350,
    L2079351,
    L2079352,
    L5472572,
    // L5234409,
    L5234410,
  ],
};

